import { PaymentMethodTypes } from './invoice';
import { NotesAll } from './notes.all';
import { LicenseArray } from './license';
import { PoolStudioSettingsGroupArray } from './poolstudio.settings.group';
import { TagArray } from './tag';

export enum LifeCycleStagetypes {
    Other = 0,
    Customer = 1,
    Subscriber = 2,
    Lead = 3,
    MarketingQualifiedLead = 4,
    SalesQualifiedLead = 5,
    Opportunity = 6,
    Evangelist = 7
}

export enum MemberStatusTypes {
    Active = 0,
    Inactive = 1,
    Closed = 2
}

export enum MemberPersonTypes {
    NotAMember = 0,
    ActiveMember = 100,
    CancelledMember = 110,
    ActiveDesigner = 200,
    CancelledDesigner = 210,
    OrphanedDesigner = 220
}

export interface IMember {
    ID: number;
    IsDesigner: boolean;
    CompanyName: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    ParentID: number;
    Parents: MemberArray;
    InfusionsoftID: number;
    Password: string;

    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;
    AuthorizedContactNote: string;

    OverrideUpdaterClientSettings_ID?: number;

    PreventAutomaticEmails: number;
    ExemptFromTax: boolean;

    HubspotVID: string;

    Address1: string;
    State: string;
    Country: string;
    ZipCode: string;
    City: string;

    AdminNote: string;
    LastLogin: Date;
    IP: string;
    Host: string;

    LifeCycleStage: LifeCycleStagetypes;
    DefaultPayMethod: PaymentMethodTypes;
    Status: MemberStatusTypes;

    Tags: TagArray;
    Notes: NotesAll;

    PoolStudioSettingsGroups: PoolStudioSettingsGroupArray;

}


export class MemberArray extends Array<Member> {

    constructor(...items: Member[]) {
        super(...items);
        Object.setPrototypeOf(this, MemberArray.prototype);
    }

}


export class Member  implements IMember {
    ID: number;
    IsDesigner: boolean;
    CompanyName: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    ParentID: number;
    Parents: MemberArray;
    Licenses: LicenseArray;
    MemberType: MemberPersonTypes;
    Address1: string;
    State: string;
    Country: string;
    ZipCode: string;
    City: string;
    InfusionsoftID: number;
    Password: string;

    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;
    AuthorizedContactNote: string;

    OverrideUpdaterClientSettings_ID?: number;

    PreventAutomaticEmails: number;
    ExemptFromTax: boolean;

    HubspotVID: string;

    AdminNote: string;
    LastLogin: Date;
    IP: string;
    Host: string;

    LifeCycleStage: LifeCycleStagetypes;
    DefaultPayMethod: PaymentMethodTypes;
    Status: MemberStatusTypes;
    PersonType: MemberPersonTypes;

    Tags: TagArray;
    Notes: NotesAll;

    PoolStudioSettingsGroups: PoolStudioSettingsGroupArray;

    public static GetMemberPersonType( myPersonType: MemberPersonTypes ): string {
        let myPersonTypeString = 'Member';

        switch (myPersonType) {
            case MemberPersonTypes.ActiveMember:
                myPersonTypeString = 'Active Member';
                break;
            case MemberPersonTypes.CancelledMember:
                myPersonTypeString = 'Cancelled Member';
                break;
            case MemberPersonTypes.ActiveDesigner:
                myPersonTypeString = 'Active Designer';
                break;
            case MemberPersonTypes.CancelledDesigner:
                myPersonTypeString = 'Cancelled Designer';
                break;
            case MemberPersonTypes.OrphanedDesigner:
                myPersonTypeString = 'Orphaned Designer';
                break;
            default:
                myPersonTypeString = 'No Member Type';
                break;
        }

        return myPersonTypeString;
    }

}
